module.exports = __webpack_public_path__ + "static/media/remotelock_logo.f31b0467.png";